import { PapRequestStatusType } from '@app/pcs/models/pap-request-status-type';

export enum PaPRequestStatusCategory {
  InvalidRequestedLocations = 'InvalidRequestedLocations',
  NonReserved = 'NonReserved',
  Reserved = 'Reserved'
}

export interface PapRequestStatus {
  status: PapRequestStatusType;
  category?: PaPRequestStatusCategory;
}
